import { useState } from 'react';

const galleryItems = [
  {
    category: 'Obras',
    title: 'Canteiro Zona Sul',
    image: 'https://storage.readdy-site.link/project_files/d1351590-8cd2-45d9-bbe4-eacb238e475e/ab7eddc8-e0bf-4f53-9048-2973db7f333e_DJI_20260317181218_0078_D.jpg?v=98333c3cb2883d10ae0531a8c4c23d5c',
  },
  {
    category: 'Imobiliária',
    title: 'Condomínio Alto de Pinheiros',
    image: 'https://public.readdy.ai/ai/img_res/7d19d15b1ec83450efc412e08eff7a92.jpg',
  },
  {
    category: 'Eventos',
    title: 'Festival Corporativo',
    image: 'https://readdy.ai/api/search-image?query=aerial%20drone%20view%20large%20outdoor%20corporate%20event%20Brazil%2C%20crowd%20gathering%20at%20night%20with%20colorful%20stage%20lights%2C%20concert%20from%20above%2C%20dramatic%20cinematic%20photography%2C%20dark%20moody%20atmosphere&width=800&height=600&seq=gal003&orientation=landscape',
  },
  {
    category: 'Mapeamento',
    title: 'Levantamento Topográfico',
    image: 'https://readdy.ai/api/search-image?query=aerial%20drone%20orthographic%20mapping%20survey%20urban%20area%20Sao%20Paulo%20Brazil%2C%20top%20down%20view%20city%20blocks%20streets%20buildings%2C%20technical%20geospatial%20photography%2C%20high%20altitude%20wide%20shot%2C%20professional%20quality&width=800&height=600&seq=gal004&orientation=landscape',
  },
  {
    category: 'Imobiliária',
    title: 'Mansão Morumbi',
    image: 'https://readdy.ai/api/search-image?query=aerial%20drone%20photography%20luxury%20mansion%20house%20Sao%20Paulo%20Brazil%2C%20large%20property%20with%20pool%20and%20garden%20from%20above%2C%20real%20estate%20premium%20photography%2C%20warm%20golden%20light%2C%20wide%20angle%20cinematic&width=800&height=600&seq=gal005&orientation=landscape',
  },
  {
    category: 'Obras',
    title: 'Viaduto Marginal',
    image: 'https://readdy.ai/api/search-image?query=aerial%20drone%20photography%20infrastructure%20bridge%20highway%20construction%20Sao%20Paulo%20Brazil%2C%20urban%20engineering%20project%20from%20above%2C%20dramatic%20wide%20angle%2C%20professional%20industrial%20photography%2C%20dark%20moody%20tones&width=800&height=600&seq=gal006&orientation=landscape',
  },
];

const categories = ['Todos', 'Obras', 'Imobiliária', 'Eventos', 'Mapeamento'];

const Galeria = () => {
  const [active, setActive] = useState('Todos');
  const [lightbox, setLightbox] = useState<null | typeof galleryItems[0]>(null);

  const filtered = active === 'Todos' ? galleryItems : galleryItems.filter((g) => g.category === active);

  return (
    <section id="galeria" className="bg-[#0d0d0d] py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-[#f5a623] text-xs font-bold tracking-widest uppercase mb-4">
            <span className="w-8 h-px bg-[#f5a623]"></span>
            Portfólio
            <span className="w-8 h-px bg-[#f5a623]"></span>
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Nossos Trabalhos
          </h2>
          <p className="text-white/50 text-base max-w-lg mx-auto">
            Uma seleção dos melhores registros aéreos realizados em São Paulo e região.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                active === cat
                  ? 'bg-[#f5a623] text-black'
                  : 'bg-white/8 text-white/60 hover:bg-white/15 hover:text-white border border-white/10'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-2xl overflow-hidden cursor-pointer h-64"
              onClick={() => setLightbox(item)}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span className="text-[#f5a623] text-xs font-bold uppercase tracking-wider">{item.category}</span>
                <div className="text-white font-bold text-base mt-1">{item.title}</div>
              </div>
              <div className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-white text-base"></i>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Solicitar Projeto Similar
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-6"
          onClick={() => setLightbox(null)}
        >
          <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <button
              className="absolute -top-12 right-0 text-white/70 hover:text-white text-3xl cursor-pointer"
              onClick={() => setLightbox(null)}
            >
              <i className="ri-close-line"></i>
            </button>
            <img
              src={lightbox.image}
              alt={lightbox.title}
              className="w-full rounded-2xl object-cover"
            />
            <div className="mt-4">
              <span className="text-[#f5a623] text-xs font-bold uppercase tracking-wider">{lightbox.category}</span>
              <div className="text-white font-bold text-lg mt-1">{lightbox.title}</div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Galeria;
